export default "__VITE_ASSET__DrRGeK1S__$_?format=webp__"